import React from 'react';
import TemplatePage from "../template_page/template_page";
import "./summer_course_page.scss";
import {isTablet} from "react-device-detect";

const SummerCourseBridge = props => {
    window.localStorage.setItem("summercourse", props.data.title)

    return <div id="summer-course" className="container-fluid">
        <div className={isTablet ? "row title-row margin-remover" : "row title-row"}>
            <div className="title">{props.data.title}</div>
        </div>
        <div className={isTablet ? "row image-row margin-remover" : "row image-row"}>
            <div className="overlay">
                <a href={props.data.right_link}><div className="right-link">{props.data.right_link_label}<span className="arrow">&#8594;</span></div></a>
            </div>
            <div className="left-column">
                <div className="left-title">{props.data.left_title}</div>
                <div className="left-description">{props.data.left_description}</div>
                <a href={props.data.left_link}><div className="left-link">{props.data.left_link_label}<span className="arrow">&#8594;</span></div></a>
                <img src={props.data.left_image} alt={props.data.left_title} />
            </div>
            <div className="right-column">
                <div className="right-title">{props.data.right_title}</div>
                <div className="right-description">{props.data.right_description}</div>
                <a href={props.data.right_link}><div className="right-link secondary">{props.data.right_link_label}<span className="arrow">&#8594;</span></div></a>
                <img src={props.data.right_image} alt={props.data.right_title} />
            </div>
        </div>
    </div>
}

class SummerCoursePage extends TemplatePage {
    beforeRightComponentsList(page) {
        return (
            <SummerCourseBridge data={page} />
        )
    }
}

export default SummerCoursePage;
